// React Imports
import React, { useEffect, useState } from "react";

// Internationalization Import
import i18n from "i18next";

// Internal Imports
import { fetchWrapper } from "../../helpers/fetchwrapper";
import { IAcademyDocumentFolder2UserDocument } from "../../Models/IAcademyDocumentFolder2UserDocument";

import { IAcademyDocumentFolder2AppUser } from "../../Models/IAcademyDocument2AppUser";
import AddAcademyParticipantDialog from "./AddAcademyParticipantDialog";
import { AcademyDocumentFolderParticipantColumns } from "./AcademyDocumentFolderParticipantColumns";
import DocumentViewer from "../../Controls/DocumentViewer";
import AddAcademyUserCertificateDialog from "./AddAcademyUserCertificateDialog";
import LuebPagedDataGrid from "../../Controls/LuebPagedDataGrid";
import { MessageBar } from "@fluentui/react-components";

// Props
interface IAcademyDocumentFolderParticipantsProps {
  isAdmin: boolean;
  academyFolderGuid?: string;
  participants?: IAcademyDocumentFolder2AppUser[];
  onRefreshRequested: any;
}

// Function
function AcademyDocumentFolderParticipants(
  props: IAcademyDocumentFolderParticipantsProps,
) {
  const [documentToView, setDocumentToView] = useState<any>(undefined);

  const [addCertificateAppUserId, setAddCertificateAppUserId] = useState<
    string | undefined
  >(undefined);

  const columns = AcademyDocumentFolderParticipantColumns({
    isAdmin: props.isAdmin,
    academyDocumentFolderGuid: props.academyFolderGuid
      ? props.academyFolderGuid
      : "",
    onChange: () => {
      // TODO: Neu laden
      props.onRefreshRequested();
    },
    onAddCertificateClicked: (appUserGuid: string) => {
      setAddCertificateAppUserId(appUserGuid);
    },
    onDocumentClicked: (doc: any) => {
      setDocumentToView(doc);
    },
  });

  return (
    <div style={{ marginTop: 10 }}>
      {props.participants && (
        <LuebPagedDataGrid
          items={props.participants}
          columns={columns}
          resizableColumns
          sortable
          columnSizingOptions={{
            certificate: {
              minWidth: 100,
              defaultWidth: 200,
            },

            delete: {
              minWidth: 50,
              defaultWidth: 50,
            },
          }}
        />
      )}

      {documentToView && (
        <DocumentViewer
          onDismiss={() => setDocumentToView(undefined)}
          title={documentToView.title}
          path={documentToView.path}
          canDownload={true}
        />
      )}

      {props.academyFolderGuid && addCertificateAppUserId && (
        <AddAcademyUserCertificateDialog
          academyDocumentFolderGuid={props.academyFolderGuid}
          appUserGuid={addCertificateAppUserId}
          onDismiss={() => {
            props.onRefreshRequested();
            setAddCertificateAppUserId(undefined);
          }}
          isDialogOpen={addCertificateAppUserId != undefined}
        />
      )}

      {props.participants && props.participants.length == 0 && (
        <MessageBar>{i18n.t<string>("noParticipants")}</MessageBar>
      )}
    </div>
  );
}

// Export Function
export default AcademyDocumentFolderParticipants;
